import React, { useState, useEffect, useContext } from "react";
import "../../styling/GalleryTab.css";
import "../../styling/ClientPortal.css";
import axios from "axios";
import { EventDataContext } from "../EventDataContext";
import { ImUpload } from "react-icons/im";
import { BsDownload, BsSend } from "react-icons/bs";

const itemsPerPage = 12;

const EventGallery = ({ brandingColours, eventId: propEventId }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const { EventData } = useContext(EventDataContext);
  const [images, setImages] = useState([]);
  const eventId = propEventId || EventData?._id;

  const fetchImages = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/galleryImages/${eventId}`,
        { withCredentials: true }
      );
      if (Array.isArray(res.data.images)) {
        setImages(res.data.images);
      } else {
        setImages([]);
      }
    } catch (err) {
      console.error("Error fetching images:", err);
      setImages([]);
    }
  };

  useEffect(() => {
    fetchImages();
  }, [eventId]);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentImages = images.slice(startIndex, startIndex + itemsPerPage);
  const totalPages = Math.ceil(images.length / itemsPerPage);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };


  const downloadAllImages = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/event/${eventId}/download-images-zip`,
      {
        responseType: 'blob',
        withCredentials: true,
      }
    );


    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `event-${eventId}-images.zip`);

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error('Error downloading ZIP:', error);
    alert('Failed to download images as ZIP.');
  }
};



  // Downloads the image without fetching blob (avoids CORS)
  // const downloadImage = (url, filename) => {
  //   const link = document.createElement("a");
  //   link.href = url;
  //   link.download = filename;
  //   link.target = "_blank"; 
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };

  return (
    <div className="gallery-container">
      <div
        className="image-grid"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "16px",
        }}
      >

        {currentImages.map((image, index) => (
          <div
            key={index}
            className="image-item"
            // style={{
            //   aspectRatio: "1 / 1",
            //   width: "100%",
            //   display: "flex",
            //   alignItems: "center",
            //   justifyContent: "center",
            //   cursor: "pointer",
            // }}
            style={{ position: "relative", overflow: "hidden", cursor: "pointer" }}
            // onClick={() => downloadImage(image.originalUrl, `image-${index}.jpg`)}
          >
            <img
              src={image.thumbnailUrl}
              alt={`Image ${index}`}
              className="img-fluid"
              style={{
                width: "320px",
                height: "220px",
                objectFit: "cover",
                borderRadius: "8px",
              }}
            />
          </div>
        ))}
      </div>

      <div className="pagination" style={{ marginTop: "16px", textAlign: "center" }}>
        <button
          style={{
            marginTop: "5px",
            width: "20%",
            height: "35px",
            background: brandingColours?.primaryColor,
            color: brandingColours?.secondaryColor,
            fontSize: "12px",
            border: "hidden",
            borderRadius: "4px",
            cursor: "pointer",
          }}
          onClick={downloadAllImages}
        >
          <BsDownload /> Download All
        </button>

        <div style={{ display: "flex", justifyContent: "center", marginTop: "8px", flexWrap: "wrap" }}>
          {Array.from({ length: totalPages }).map((_, index) => (
            <div
              key={index}
              className="page-item"
              style={{
                backgroundColor: index + 1 === currentPage ? brandingColours?.primaryColor : "transparent",
                color:
                  index + 1 === currentPage
                    ? brandingColours?.secondaryColor
                    : brandingColours?.primaryColor,
                borderColor: brandingColours?.primaryColor,
                cursor: "pointer",
                padding: "8px 16px",
                borderRadius: "4px",
                border: "1px solid",
                margin: "4px",
              }}
              onClick={() => handlePageChange(index + 1)}
            >
              {index + 1}
            </div>
          ))}
        </div>
      </div>

      {/* <div className="right-panel" style={{ marginTop: "0px", width: "20%", height: "auto", paddingLeft: "1%"}}>
        <button style={{ height: "30px", fontSize: "15px", background: "#2A1980", color: "#FFFFFF", marginLeft: "10px" }}  onClick={downloadAllImages}>
        <BsDownload /> Download All
                </button>
      </div> */}
    </div>
  );
};

export default EventGallery;
